import { render } from "./PrismaDiagram1.vue?vue&type=template&id=1b536d79"
import script from "./PrismaDiagram1.vue?vue&type=script&lang=js"
export * from "./PrismaDiagram1.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__